<template>
    <div class="row">
      <div class="col-12 card">
        <h4>История рейсов</h4>
        <div class="row justify-content-space-between">
            <div class="col-12">
              <div class="row" v-if="Orders">
                <OrdersList/>
              </div>
            </div>
        </div>

      </div>
    </div>
</template>

  <script>
    import OrdersList from "@/components/Polygon/History/OrdersList.vue";
    import moment from 'moment'

    export default {
      components: { OrdersList },
      data() {
        return {
          title: "Список рейсов",
        }
      },
      computed: {
        currentUser() {
          return this.$store.state.auth.user;
        },
        Orders() {
          return this.$store.state.polygon_orders
        },
      },
      methods: {
        today_date(){
            const today = new Date();
            return moment(String(today)).format('YYYY-MM-DD')
        },
      },
      created() {
          this.$store.dispatch("fetchPolygonOrders", { inn: this.currentUser.company_inn, start_date: "2024-01-01", end_date: this.today_date() });
      },
    };
  </script>
